import type {Schemas} from 'domainTypes/dto';
import {mapWorkToSeriesRelationDto} from 'services/agent/mappers/mapRelationsDto';
import {mapToVerifiedDto} from 'services/utils';
import type {Collection} from '../types';
import {sortCollectionLinks} from '../functions';
import {
  mapCollectionTypeDto,
  mapToCollectionTypeDto,
} from './mapCollectionTypeDto';

export const mapGetCollectionDto = (
  dto: Schemas.SeriesWithRelationsDto,
): Collection => {
  let links = (dto.relations ?? []).map(relationDto =>
    mapWorkToSeriesRelationDto(relationDto),
  );
  links = sortCollectionLinks(links);
  return {
    id: dto.id,
    collectionType: mapCollectionTypeDto(dto.seriesType),
    titles: dto.titles,
    note: dto.note,
    verified: dto.verified,
    links,
  };
};

export const mapToUpsertCollectionDto = (
  collection: Omit<Collection, 'id'> & Partial<Pick<Collection, 'id'>>,
): Schemas.CreateOrUpdateSeriesDto => {
  return {
    titles: collection.titles,
    seriesType: mapToCollectionTypeDto(collection.collectionType),
    note: collection.note,
    verified: mapToVerifiedDto(collection.id, collection.verified),
  };
};
